import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as beneficiariesState from '../employee-detail.reducer';
import * as beneficiariesReducer from '../reducers/beneficiaries.reducer';

export const getBeneficiaries = createSelector(beneficiariesState.getBeneficiariesState, beneficiariesReducer.getBeneficiaries);
export const getBeneficiary = createSelector(beneficiariesState.getBeneficiariesState, beneficiariesReducer.getBeneficiary);
